/* eslint-disable import/prefer-default-export */
export { openModal } from './openModal';
export { closeModal } from './openModal';
